import { cn } from '@/lib/utils';

export function Logo({ className }: { className?: string }): JSX.Element {
  return (
    <>
      <img
        src="/zorro-logo.png"
        alt="Zorro"
        className={cn('block w-auto dark:hidden', className)}
      />
      <img
        src="/zorro-logo-white.png"
        alt=""
        aria-hidden
        className={cn('hidden w-auto dark:block', className)}
      />
    </>
  );
}
